import { Component, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { NavigationService } from "src/app/providers/navigation.service";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";

@Component({
  selector: "sm-employee-current-pack-recharge",
  templateUrl: "./employee-current-pack-recharge.component.html",
  styleUrls: ["./employee-current-pack-recharge.component.scss"],
})
export class EmployeeCurrentPackRechargeComponent implements OnInit {
  loader: boolean = false;
  employeeHash: any
  apisub: Subscription
  currentPlan:any = []
  constructor(
    private navservice: NavigationService,
    private router: Router,
    private loaderservice: LoaderServiceService,
    private _apiService: ApiService, 
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
  ) {
    this.navservice.hideSidebarAndNav = false;
    this.apisub = this._apiService.apiResult.subscribe(resData =>{
      if(resData.responseType === SM_CONSTANTS.RESULT_API_GET_EMPLOYEE_SUBSCRIPTION_INFO){
        this.currentPlan = []
        if(resData.result){
          this.currentPlan = resData.result
          
        }
        this.loader = false;
        this.loaderservice.showLoader = false
         if (
          sessionStorage.getItem("showToastAfterRechargeEmployee") &&
          sessionStorage.getItem("showToastAfterRechargeEmployee") == "1"
        ) {
          this.snackBar.open("Premium pack for this employee recharged successfully.", "Ok", {
            duration: 3000,
            horizontalPosition: "center",
            verticalPosition: "bottom",
          });
          sessionStorage.removeItem('showToastAfterRechargeEmployee')
        }
      }
    })
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(data =>{
      this.loader = true;
      this.loaderservice.showLoader = true;
      this.employeeHash = data.employeeHash
      this._apiService.getEmployeeSubscriptionInfo(this.employeeHash);

    })
  }
  goToRenew(){
    this.router.navigate(['purchased-plan'], {queryParamsHandling: 'preserve', relativeTo: this.route})
  }
}
